export default __webpack_public_path__ + "static/header-i-92f7fe1c81682aae2bb961f2cd963bdc.svg";